import { yupResolver } from '@hookform/resolvers/yup';
import AppBar from '@mui/material/AppBar';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import * as yup from 'yup';
import _ from '@lodash';
import { startLoading, stopLoading } from 'app/store/utilSlice';
import { selectItemById, updateFileItem } from 'app/store/fileItemsSlice';
import { useSelector, useDispatch } from 'react-redux';
import { dispatchResultMessage } from '../utils';
import ControlledTextField from '../form/ControlledTextField';
import DefaultButton from '../layout/DefaultButton';
import ControlledCheckbox from 'app/shared-components/form/ControlledCheckbox';

/**
 * Form Validation Schema
 * 
 */
const schema = yup.object().shape({
  name: yup.string().required('You must enter a file name'),
  description: yup.string(),
  knowledgeBase: yup.boolean(),
});

  
function EditFileDialog(props) {
  const { itemId, onCloseDialog } = props;
  const dispatch = useDispatch(); 
  const item = useSelector((state) => selectItemById(state, itemId));
  const open= Boolean(itemId);
  if (!item) return null;

  
  const defaultValues = {
	  name: '',
	  description: '',
	  knowledgeBase: false,
  };
	
  const values = {
	  name: item ? item.name : '',
	  description: item ? item.description : '',
	  knowledgeBase: item ? item.knowledgeBase : false,
  };
  
  const { handleSubmit, formState, control, reset } = useForm({
    mode: 'onChange',
    defaultValues: defaultValues,
    values: values,
    resolver: yupResolver(schema),
  });

  const { isValid, dirtyFields, errors } = formState;
  
  useEffect(() => {
    reset({ ...item });
  }, [ item, reset]);

  function handleCloseDialog() {
    onCloseDialog();
  }

  function handleDiscard() {
    onCloseDialog();
  }

  
  function onSubmit(data){
	  if (!item) return;
	  
	  //set the loading flag and close the dialog
	  dispatch(startLoading());
    onCloseDialog();
	  
	  //Upload file and update user data
	  dispatch(updateFileItem({fileId: itemId, 
		                       name: data.name, 
		                       knowledgeBase: data.knowledgeBase,
		                       description: data.description})).then((resp) => {
	   	dispatchResultMessage(dispatch, resp, "Updated File")
     });
  }


  return (
      
      <Dialog
        open={open}
        onClose={handleCloseDialog}
        aria-labelledby="form-dialog-title"
        scroll="body"
      >
        <AppBar position="static" color="secondary" elevation={0}>
          <Toolbar className="flex w-full">
            <Typography variant="subtitle1" color="inherit">
              Update File
            </Typography>
          </Toolbar>
        </AppBar>

        <form noValidate onSubmit={handleSubmit(onSubmit)} className="flex flex-col">
          <DialogContent classes={{ root: 'p-16 pb-0 sm:p-32 sm:pb-0' }}>
            <ControlledTextField name="name" label="File name"
                             control={control} errors={errors}
             				 autoFocus required fullWidth />
        
            <ControlledTextField name="description" label="File description"
                             control={control} errors={errors}
             				 required fullWidth />
             				 
            <ControlledCheckbox name="knowledgeBase" control={control} errors={errors}
			                       label={"Include in AI Knowledge Base?"}/>  
          </DialogContent>

          <DialogActions className="flex flex-col sm:flex-row sm:items-center justify-between py-16 sm:py-24 px-24">

            <div className="flex items-center space-x-8 mt-16 sm:mt-0">
              <DefaultButton text="Cancel" onClick={handleDiscard} />
              <DefaultButton text="Update"
	              disabled={_.isEmpty(dirtyFields) || !isValid}
	              submit />
            </div>
          </DialogActions>
        </form>
      </Dialog>
  );
}

export default EditFileDialog;
